import { render } from "./ClientForm.vue?vue&type=template&id=5e73d3f3&ts=true"
import script from "./ClientForm.vue?vue&type=script&lang=ts"
export * from "./ClientForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__